<template>
  <div>

    <b-form-group>
      <div class="d-flex justify-content-between">
        <label :for="id">{{ label }}</label>
        <b-link :to="{ name: path }">
          <small>{{ text }}</small>
        </b-link>
      </div>
      <validation-provider
        #default="{ errors }"
        :name="errorName"
        :rules="rules"
        :vid="vid"
      >
        <b-input-group
          class="input-group-merge"
        >
          <b-form-input
            :id="id"
            v-model="innerValue"
            :type="passwordFieldType"
            class="form-control-merge"
            :state="errors.length > 0 ? false : null"
            :name="id"
            :for="id"
            :readonly="readonly"
            placeholder="Password"
            autocomplete="off"
          />

          <b-input-group-append
            v-if="showPasswordIcon"
            is-text
          >
            <feather-icon
              class="cursor-pointer"
              :icon="passwordToggleIcon"
              @click="togglePasswordVisibility"
            />
          </b-input-group-append>
        </b-input-group>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </div>
</template>

<script>
import {
  BFormInput, BInputGroup, BInputGroupAppend, BLink, BFormGroup,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
  name: 'InputPasswordField',
  components: {
    BFormInput,
    BInputGroup,
    BFormGroup,
    BLink,
    BInputGroupAppend,
    ValidationProvider,
  },
  mixins: [togglePasswordVisibility],
  props: {
    label: {
      type: String,
      required: false,
      default: null,
    },
    text: {
      type: String,
      required: false,
      default: null,
    },
    errorName: {
      type: String,
      default: 'default',
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    path: {
      type: String,
      required: false,
      default: null,
    },
    id: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
    },
    value: {
      type: null,
      default: '',
    },
    vid: {
      type: String,
      default: '',
    },
    showPasswordIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      innerValue: '',
    }
  },
  computed: {
    hasValue() {
      return !!this.innerValue
    },
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  watch: {
    innerValue(value) {
      this.$emit('input', value)
    },
    value(val) {
      if (val !== this.innerValue) {
        this.innerValue = val
      }
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
}
</script>
